import { Component } from '@angular/core';
import { NavController, NavParams, PopoverController, ModalController, ToastController, AlertController } from 'ionic-angular';
import { DIC } from '../../../dic';
import { GN } from '../../../../gn';
import * as moment from 'moment';
import { PopupPage } from '../../../popup/popup';
import { CalendarPage } from '../../../calendar/calendar';
import { NeworderbankPage } from '../neworderbank/neworderbank';
import { RoutingnalogbankPage } from './routingnalogbank';
import { PoinotePage } from '../../../poinote/poinote';
import { PrintreportPage } from './printreport';
import { HistorylognalogPage } from './historylognalog';
import { RouteonmapPage } from '../../routeonmap/routeonmap';

/**
 * Generated class for the CurrentfuturebanknalogPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-currentfuturebanknalog',
  templateUrl: 'currentfuturebanknalog.html',
})
export class CurrentfuturebanknalogPage {
  startDateA: any = new Date()
  startDateStrA: any = moment(new Date()).format(this.gn.user.DFormat)
  startDateB: any = new Date()
  startDateStrB: any = moment(new Date()).format(this.gn.user.DFormat)

  selectedVehicleName = '--- ' + this.dic.l["choosevehicle"] + ' ---';
  selectedVehicleID = -1;

  InFocused = false
  AutoCompleteShow2 = false
  AutoCompleteState2 = 0
  LoadingDataSearch2 = false
  mapSearcData2 = []
  AutoCompleteTitle = ''
  r_routeName = ''
  r_routeId = 0
  loadingData = false


  reportData = []


  reportDataToday = []
  reportDataOld = []
  reportDataNew = []
  reportDDD = []
  tmpGoran = 1
  r_routeNumber = ''

  mdl

  Denes = moment(new Date()).format('YYYY-MM-DD')
  Denesenden: any = new Date()

  changedbank = []
  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public gn: GN, public popoverCtrl: PopoverController, public modalCtrl: ModalController, public toastCtrl: ToastController, public alertCtrl: AlertController) {
    this.routeChanged()

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad CurrentfuturebanknalogPage');
    this.loadReport();

  }

  openVehiclePopup(_ev) {

    var _that = this
    let popover = this.popoverCtrl.create(PopupPage, {
      type: 'vehicles-routing', selected: [], callback: function (_text, _ids) {

        // console.log(_text, _ids)
        // _that.selectedVehiclesIds = _ids
        // _that.selectedVehiclesText = _text

        _that.selectedVehicleName = _text;
        _that.selectedVehicleID = parseInt(_ids);

        // console.log(_that.selectedVehicleID, _that.selectedVehicleName)
      }
    });
    popover.present({
      ev: _ev
    });
  }

  routeChanged() {
    var _that = this
    this.gn._Post('/api/gn/routeChangedBank', { fromuid: this.gn.crypt(this.gn.user.UserId) }, function (_data) {
      _that.changedbank = _data
      console.log(_data, 'daj da vidam data')
    })
  }



  searchGeocode2(txt) {
    txt = txt.toLowerCase()
    // txt = txt.replace(/ /g,'%')
    // console.log(txt)
    if (txt == '' || txt.length <= 3) {
      this.mapSearcData2 = []
      this.AutoCompleteState2 = 0
      return
    }
    var _that = this
    var _lon = 21.431068
    var _lat = 41.995759

    this.LoadingDataSearch2 = true
    _that.AutoCompleteState2 = 1

    if (txt != '' && txt.length > 3) {
      this.gn.Socket.emit({ query: txt, lon: _lon, lat: _lat, clientid: this.gn.user.ClientId }, function (_data) {
        //  console.log(_data)
        _that.mapSearcData2 = []
        for (var i = 0; i < _data.length; i++) {
          if (_data[i].ppid + '' != '0') {
            _that.mapSearcData2.push(_data[i])
          }
        }

        _that.LoadingDataSearch2 = false
        if (_that.mapSearcData2.length == 0) {
          _that.AutoCompleteState2 = 2
        } else {
          _that.AutoCompleteState2 = 1
        }
        // console.log (_that.mapSearcData)
      }, 'getgeocodenlb')
    }
  }

  openAutocomplete2(_ev) {

    this.mapSearcData2 = []
    this.LoadingDataSearch2 = false
    this.AutoCompleteState2 = 0

    this.InFocused = true
    var _txt = _ev.target.value
    if (_txt == '') {
      _txt = this.dic.l['Search'] + '...'
      this.AutoCompleteState2 = 0
    } else {
      _txt = this.dic.l['Search'] + ': ' + _txt
      this.AutoCompleteState2 = 1
    }
    this.searchGeocode2(_ev.target.value)
    // this.AutoCompleteTitle2 = _txt
    // var _top = _ev.target.parentNode.parentNode.parentNode.parentNode.parentNode.offsetTop
    this.AutoCompleteShow2 = true
    // this.AutoCompleteTop = (_top + 71) + 'px'
  }
  hideAutocomplete2() {
    //if (this.r_routeName == '') { this.selectedPoiRep = null }
    this.InFocused = false
    var _that = this
    setTimeout(function () {
      if (_that.InFocused == false) {
        _that.AutoCompleteShow2 = false
      }
    }, 150)
    // this.AutoCompleteShow = false
  }
  txtchange2(_ev) {
    var _txt = _ev.target.value
    var t = _ev.target.value
    if (_txt == '') {
      _txt = this.dic.l['Search'] + '...'
    } else {
      _txt = this.dic.l['Search'] + ': ' + _txt
    }
    // this.AutoCompleteTitle = _txt


    // var _that = this
    if (t != '') {
      this.searchGeocode2(_ev.target.value)
    } else {
      this.mapSearcData2 = []
      this.AutoCompleteState2 = 0
      // console.log (_that.mapSearcData)
    }
  }

  itemACClick2(_itm) {
    this.AutoCompleteShow2 = false
    this.r_routeName = _itm.name
    this.r_routeId = _itm.ppid
  }



  // openDatePopup(_ev, _startend) {
  //   var whoDate = this.startDate
  //   if (_startend == 'e') {
  //     whoDate = this.endDate
  //   }
  //   var _that = this;
  //   let popover = this.popoverCtrl.create(CalendarPage, {
  //     d: whoDate, cb: function (d) {
  //       var dr = _that.getDateRange()
  //       // console.log(d)
  //       console.log(_startend, d, _that.startDate, _that.endDate)
  //       if (_startend == 's') {
  //         var ddiff = _that.getDateDifff(d, _that.endDate)
  //         // if (ddiff>dr){
  //         //   var _msg = _that.dic.l["IzbravteLosDatum"]
  //         //   _msg = _msg.replace('@@@', dr+'')
  //         //   const toast = _that.toastCtrl.create({ message: _msg, duration: 3000, position: 'top' });
  //         //   toast.present();
  //         //   return
  //         // }
  //         if (ddiff <= 0) {
  //           _that.endDate = d;
  //           _that.endDateStr = moment(_that.endDate).format(_that.gn.user.DFormat)
  //           // const toast = _that.toastCtrl.create({ message: _that.dic.l["IzbravteLosDatum2"], duration: 3000, position: 'top' });
  //           // toast.present();
  //           // return
  //         }
  //         _that.startDate = d;
  //         _that.startDateStr = moment(_that.startDate).format(_that.gn.user.DFormat)

  //       } else {
  //         var ddiff = _that.getDateDifff(_that.startDate, d)
  //         // if (ddiff>dr){
  //         //   var _msg = _that.dic.l["IzbravteLosDatum"]
  //         //   _msg = _msg.replace('@@@', dr+'')
  //         //   const toast = _that.toastCtrl.create({ message: _msg, duration: 3000, position: 'top' });
  //         //   toast.present();
  //         //   return
  //         // }
  //         if (ddiff <= 0) {
  //           _that.startDate = d;
  //           _that.startDateStr = moment(_that.startDate).format(_that.gn.user.DFormat)
  //           // const toast = _that.toastCtrl.create({ message: _that.dic.l["IzbravteLosDatum2"], duration: 3000, position: 'top' });
  //           // toast.present();
  //           // return
  //         }
  //         _that.endDate = d;
  //         _that.endDateStr = moment(_that.endDate).format(_that.gn.user.DFormat)
  //       }
  //       _that.startDateYMD = moment(_that.startDate).format('YYYY-MM-DD')
  //       _that.endDateYMD = moment(_that.endDate).format('YYYY-MM-DD')

  //     }
  //   })
  //   popover.present({ ev: _ev });
  // }


  openDatePopup(_ev, _se) {
    var dd = this.startDateA
    if (_se == 2) {
      dd = this.startDateB
    }
    var _that = this;
    let popover = this.popoverCtrl.create(CalendarPage, {
      d: dd, cb: function (d) {
        // if (_se == 1) {
        //   _that.startDateA = d;
        //   _that.startDateStrA = moment(_that.startDateA).format(_that.gn.user.DFormat)
        // } else {
        //   _that.startDateB = d;
        //   _that.startDateStrB = moment(_that.startDateB).format(_that.gn.user.DFormat)
        // }
        // // tuka pocnuvaat alertite 

        // var alertMinusDenesenDen = _that.getDateDifff(_that.startDateA, _that.Denesenden)
        // if (alertMinusDenesenDen == 0) {
        //   alertMinusDenesenDen = -1
        // }
        // if (Math.sign(alertMinusDenesenDen) == -1) {
        //   _that.startDateA = new Date()
        //   _that.startDateStrA = moment(_that.startDateA).format(_that.gn.user.DFormat)
        //   const toast = _that.toastCtrl.create({ message: _that.dic.l["IzbravteLosPocetenDatum"], duration: 3000, position: 'top' });
        //   toast.present();
        //   return
        // }


        if (_se == 1) {
          var ddiff = _that.getDateDifff(d, _that.startDateB)

          if (ddiff <= 0) {
            _that.startDateB = d;
            _that.startDateStrB = moment(_that.startDateB).format(_that.gn.user.DFormat)
          }
          _that.startDateA = d;
          _that.startDateStrA = moment(_that.startDateA).format(_that.gn.user.DFormat)

        } else {
          var ddiff = _that.getDateDifff(_that.startDateA, d)
          if (ddiff <= 0) {
            _that.startDateA = d;
            _that.startDateStrA = moment(_that.startDateA).format(_that.gn.user.DFormat)
          }
          _that.startDateB = d;
          _that.startDateStrB = moment(_that.startDateB).format(_that.gn.user.DFormat)
        }



        var alertMinusDenesenDen = _that.getDateDifff(_that.startDateA, _that.Denesenden)
        console.log(alertMinusDenesenDen, 'alertMinusDenesenDen')

        if (alertMinusDenesenDen == 0 || alertMinusDenesenDen == 1) {
          alertMinusDenesenDen = -1
        }
        if (Math.sign(alertMinusDenesenDen) == 1) {
          console.log('tuka treba da nappravis toast')
          _that.startDateA = new Date()
          _that.startDateStrA = moment(_that.startDateA).format(_that.gn.user.DFormat)
          _that.startDateB = new Date()
          _that.startDateStrB = moment(_that.startDateB).format(_that.gn.user.DFormat)
          // _that.startDateB = new Date()
          // _that.startDateStrB = moment(_that.startDateA).format(_that.gn.user.DFormat)
          const toast = _that.toastCtrl.create({ message: _that.dic.l["IzbravteLosPocetenDatum"], duration: 3000, position: 'top' });
          toast.present();
          return
        }

        // var changeStartDate = _that.getDateDifff(_that.startDateA, _that.startDateB)
        // if (changeStartDate == 0) {
        //   changeStartDate = -1
        // }
        // if (Math.sign(changeStartDate) == -1) {
        //   _that.startDateA = _that.startDateB
        //   _that.startDateStrA = _that.startDateStrB
        // }

        // var changeEndDate = _that.getDateDifff(_that.startDateB, _that.startDateA)
        // if (changeEndDate == 0) {
        //   changeEndDate = -1
        // }
        // if (Math.sign(changeEndDate) == -1) {
        //   _that.startDateB = _that.startDateA
        //   _that.startDateStrB = _that.startDateStrA
        // }
        // console.log(changeStartDate, 'changeStartDate')
        // console.log(alertMinusDenesenDen, 'minusdenesNe')
      }
    })
    popover.present({ ev: _ev });
  }

  // getfutureroutes


  getDateDifff(_d1, _d2) {
    var d1 = moment(moment(_d1).format('YYYY-MM-DD')); //todays date
    var d2 = moment(moment(_d2).format('YYYY-MM-DD')); //todays date
    var momentalendate = moment(moment(this.Denesenden).format('YYYY-MM-DD')); //todays date
    // (this.Denesenden > d1){

    // }

    // if (momentalendate > d1) {
    //   console.log('blusku e')
    // }
    // console.log(momentalendate, 'momentalen date')
    // console.log(d1, 'daj da vidam d1')
    // if (d1 > d2) {
    //   console.log('dali moze vakaso pogolemo pomalo')
    // }
    var duration = moment.duration(d2.diff(d1));
    var days = 1 + duration.asDays();
    // if (days == 0) {
    //   days = -1
    // }
    // if (Math.sign(days) == -1) {
    //   console.log('tuka alert')
    // } else {
    //   console.log('return days ')
    // }
    // console.log(days, 'daj da vidam days')
    return days
  }

  getDateDifffMonth(_d1, _d2) {
    var d1 = moment(moment(_d1).format('YYYY-MM-DD')); //todays date
    var d2 = moment(moment(_d2).format('YYYY-MM-DD')); //todays date
    var duration = moment.duration(d2.diff(d1));
    var months = duration.asMonths();
    return parseInt(months + '')
  }


  sec2str2(_sec) {
    if (_sec >= 0) {
      var str = '';
      var h = Math.floor(_sec / 3600);//moment.utc(_sec * 1000).format('H');
      var m = moment.utc(_sec * 1000).format('m');
      var s = moment.utc(_sec * 1000).format('s');
      if (_sec < 60) {
        str = s + this.dic.l["sec"];
      }
      else {
        if (_sec < 3600) {
          str = m + this.dic.l["min"] + ' ' + s + this.dic.l["sec"]
        }
        else {
          str = h + this.dic.l["h"] + ' ' + m + this.dic.l["min"]
        }
      }
      // console.log("sec2str2")  
      return str;
    }
    else {
      return -1;
    }
  }

  editBankRoute(_idxmaster, _id) {
    var _that = this
    console.log(this.reportData[_idxmaster])

    this.mdl = this.modalCtrl.create(NeworderbankPage, {
      ref: this, id: _id, edittype: 'editroute', routedata: this.reportData[_idxmaster],
      cb: function () {
        _that.routeChanged()
        setTimeout(() => {
          _that.loadReport();
        }, 1000);
      }
    }, { cssClass: "modal-fullscreen" }
    );
    this.mdl.present()
  }

  showOnMap(_idxmaster, _id) {
    var _that = this
    this.gn._Post('/api/gn/getroutesOneBank', { pre: this.gn.crypt('0'), cid: this.gn.crypt(this.gn.user.ClientId), nid: this.gn.crypt(_id) }, function (_data) {
      let profileModal = _that.modalCtrl.create(RoutingnalogbankPage, {
        cb: function (_id) {
        }, rid: _id, pois: _data
      });
      profileModal.present();
    })

  }

  openMapVisited(_poi) {
    if (_poi.lonvisited == null || _poi.latvisited == null)
      return false;

    var _that = this
    var _dat = {
      ppid: this.gn.crypt(_poi.id),
      lonvisited: this.gn.crypt(_poi.lonvisited),
      latvisited: this.gn.crypt(_poi.latvisited)
    }

    this.gn._Post('/api/gn/getpoilonlat', _dat, function (_data) {
      let modal = _that.modalCtrl.create(RouteonmapPage, {
        //ppid: _poiid,
        dist: _data[0].dist,
        name: _poi.name,
        radius: _data[0].radius,
        lonpoi: _data[0].long,
        latpoi: _data[0].lat,
        lonvisited: _poi.lonvisited,
        latvisited: _poi.latvisited,
        cb: function () {
          //_that.loadData()
        }
      }
      );
      modal.present();
    })
  }
  loadReport() {
    this.tmpGoran = 1
    //this.showReportPanel = true
    this.loadingData = true
    this.reportData = []
    this.reportDataToday = []
    this.reportDataOld = []
    this.reportDataNew = []
    this.reportDDD = []
    var d1 = moment(this.startDateA).format('YYYY-MM-DD')
    var d2 = moment(this.startDateB).format('YYYY-MM-DD')
    var ppid = ''
    if (this.r_routeId != null && this.r_routeId > 0) {
      ppid = this.r_routeId + ''
    }

    var vid = '0'
    if (this.selectedVehicleID + '' != '-1') {
      vid = this.selectedVehicleID + ''
      var vida = [];
      vida.push(vid)
    }
    var _dat = {
      num: this.gn.crypt(this.r_routeNumber),
      vid: this.gn.crypt(vid),
      d1: this.gn.crypt(d1),
      d2: this.gn.crypt(d2),
      poiid: this.gn.crypt(ppid),
      uid: this.gn.crypt(this.gn.user.UserId),
      udid: this.gn.crypt(this.gn.user.driverid)
    }
    var logvozila = ' за сите возила';
    if (vid != '0') {
      logvozila = ' за возилата: ' + this.gn.getVehiclesLog(vida);
    }

    var logNalog = '; Налог бр: ' + (this.r_routeNumber == '' ? '/' : this.r_routeNumber) + '; '
    var logPoi = ' Точка од интерес: ' + (this.r_routeId == null ? '/' : this.r_routeName)
    var logperiod = 'Период од: ' + moment(d1).format('DD-MM-YYYY 00:00:00') + ' до: ' + moment(d2).format('DD-MM-YYYY 23:59:59');
    this.gn.addLog(37, logperiod + logvozila + logNalog + logPoi);

    var _that = this
    this.gn._Post('/api/gn/routingfuture', _dat, function (_data) {
      console.log(_data, 'daj da vidam data')
      // console.log(_data, 'data')
      //debugger;
      _that.loadingData = false
      var _lasttourid = ''
      _that.reportData = []
      var _pois = []
      var poiIdx = 1
      for (var i = 0; i < _data.length; i++) {

        if (_data[i].tourid + '' != _lasttourid) {

          if (_that.reportData.length > 0) {
            _that.reportData[_that.reportData.length - 1].pois = []
            for (var j = 0; j < _pois.length; j++) {
              _that.reportData[_that.reportData.length - 1].pois.push(_pois[j])
            }
            _that.reportData[_that.reportData.length - 1].poisArr = _pois
            _that.reportData[_that.reportData.length - 1].poisStr = _pois.join(', ')
            // _that.reportData[_that.reportData.length-1].pois = _pois
          }
          _pois = []
          poiIdx = 1
          var soferi = []
          if (_data[i].s1 != null) { soferi.push(_data[i].s1) }
          if (_data[i].s2 != null) { soferi.push(_data[i].s2) }
          if (_data[i].s3 != null) { soferi.push(_data[i].s3) }
          if (_data[i].s4 != null) { soferi.push(_data[i].s4) }
          _data[i].sofer = soferi.join(', ')

          var dt = new Date(_data[i].startdate);
          dt.setSeconds(dt.getSeconds() + parseInt(_data[i].totaltime));

          if (dt < new Date) _data[i].routeinfo = 'finish'
          else {
            if ((new Date) > (new Date(_data[i].startdate)) && (new Date) < dt) _data[i].routeinfo = 'current'
            else _data[i].routeinfo = 'future'
          }

          _data[i].datum = moment(_data[i].startdate).format(_that.gn.user.DFormat + ' HH:mm')
          _data[i].dYMD = moment(_data[i].startdate).format('YYYY-MM-DD')

          _data[i].distance = parseFloat(_data[i].totalkm).toFixed(1) + ' Km'
          _data[i].ttime = parseInt(_data[i].totaltime)
          var _pauses = []
          if (_data[i].pause1 + '' != '0') { _pauses.push(_data[i].pause1 + ' ' + _that.dic.l["min"]) }
          if (_data[i].pause2 + '' != '0') { _pauses.push(_data[i].pause2 + ' ' + _that.dic.l["min"]) }
          if (_data[i].pause3 + '' != '0') { _pauses.push(_data[i].pause3 + ' ' + _that.dic.l["min"]) }
          if (_data[i].pause4 + '' != '0') { _pauses.push(_data[i].pause4 + ' ' + _that.dic.l["min"]) }
          if (_data[i].pause5 + '' != '0') { _pauses.push(_data[i].pause5 + ' ' + _that.dic.l["min"]) }
          _data[i].pauses = _pauses.join(', ')
          _lasttourid = _data[i].tourid + ''

          _that.reportData.push(_data[i])
        }

        if (_that.gn.user.driverid + '' == '-1') {
          _that.reportData.sort(function (a, b) {
            return a.tourid - b.tourid;
          });
        }
        // _that.reportData
        // let sortedArray = _that.reportData.sort((a, b) => a.valueOf() - b.valueOf())
        //_pois.push('  [' + poiIdx + '. ' + _data[i].name + ' ' + _data[i].rbr1 + ' ' + _data[i].timeinp + ' ' + _data[i].timeoutp + ' ' + _that.sec2str2(_data[i].diff) + ']')
        //_pois.push({ idx: poiIdx, name: _data[i].name, id: _data[i].poiid, checked: _data[i].checked, rbr1: _data[i].rbr1, timein: _data[i].timeinp, timeout: _data[i].timeoutp, idle: _that.sec2str2(_data[i].diff) })

        //_pois.push('  [' + poiIdx + '. ' + _data[i].name + ' ' + _data[i].rbr1 + ' ' + _data[i].timeinp + ' ' + _data[i].timeoutp + ' ' + _that.sec2str2(_data[i].diff) + ']')
        var note = _data[i].note;//''
        var noteid = _data[i].noteid;//-1
        var visited = '0'

        //if (_that.gn.user.driverid + '' != '-1') {
        note = _data[i].note + '' != '' ? _data[i].note : '';
        noteid = _data[i].noteid + '' != '-1' ? _data[i].noteid : -1;
        visited = (_data[i].visited == null ? '0' : _data[i].visited);
        console.log(_data[i], 'data od i')

        var _dtbank = _data[i].dtbank

        _pois.push({ barcode: _data[i].barcode, dtbank: _dtbank, person: _data[i].officialname, amount: _data[i].moneyamount, appcolor: _data[i].appcolor, lonvisited: _data[i].lonvisited, latvisited: _data[i].latvisited, lon: _data[i].longitude, lat: _data[i].latitude, visited: visited, note: note, noteid: noteid, idx: poiIdx, name: _data[i].name, id: _data[i].poiid, checked: _data[i].checked, rbr1: _data[i].rbr1, timein: _data[i].timeinp, timeout: _data[i].timeoutp, idle: _that.sec2str2(_data[i].diff), diff: _data[i].diff })
        // console.log('kolku pati vlagas tuka')
        poiIdx = poiIdx + 1

      }
      if (_that.reportData.length > 0) {
        _that.reportData[_that.reportData.length - 1].pois = []
        for (var j = 0; j < _pois.length; j++) {
          _that.reportData[_that.reportData.length - 1].pois.push(_pois[j])
        }
        _that.reportData[_that.reportData.length - 1].poisArr = _pois
        _that.reportData[_that.reportData.length - 1].poisStr = _pois.join(', ')
        // _that.reportData[_that.reportData.length-1].pois = _pois
      }
      for (let i = 0; i < _that.reportData.length; i++) {
        if (_that.reportData[i].pois.length >= 2) {
          // _that.reportData[i].visible = true
          _that.reportData[i].show = _that.gn.user.driverid + '' == '-1' ? false : true;
        }
      }
      _that.reportData.reverse()


      // for (var i = 0; i < _that.reportData.length; i++) {
      //   if (_that.reportData[i].dYMD < _that.Denes) {
      //     _that.reportDataOld.push(_that.reportData[i])
      //   }
      //   if (_that.reportData[i].dYMD == _that.Denes) {
      //     _that.reportDataToday.push(_that.reportData[i])
      //   }
      //   if (_that.reportData[i].dYMD > _that.Denes) {
      //     _that.reportDataNew.push(_that.reportData[i])
      //   }
      // }
      // //debugger
      // console.log(_that.reportDDD, '_that.reportDDD')
      // if (_that.gn.user.driverid + '' == '-1')
      //   _that.reportDDD.push({ title: 'Идни налози', data: _that.reportDataNew })
      // _that.reportDDD.push({ title: 'Денешни налози', data: _that.reportDataToday })
      // if (_that.gn.user.driverid + '' == '-1')
      //   _that.reportDDD.push({ title: 'Изминати налози', data: _that.reportDataOld })

      // _that.reportData = _data
      // console.log(_that.reportData)
      for (let pp = 0; pp < _that.reportData.length; pp++) {
        _that.reportData[pp].changedroute = false
        for (let ll = 0; ll < _that.changedbank.length; ll++) {
          if (_that.changedbank[ll].naloghederid == _that.reportData[pp].tourid) {
            _that.reportData[pp].changedroute = true
          }
        }
      }
      console.log(_that.reportData, 'daj da vidam report data')



      setTimeout(function () {
      }, 200)
      _that.gn.xlsFunction = function () {
        //_that.createXLS()
      }


    })
  }

  openPredPois(_idx) {
    this.reportData[_idx].show = !this.reportData[_idx].show;
    if (this.reportData[_idx].show) {
      this.gn.routesChanges[this.reportData[_idx].tourid] = 0;
    } else {
      this.gn.routesChanges[this.reportData[_idx].tourid] = 0;
      for (var i = 0; i < this.gn.routesChangesPois.length; i++) {
        if (this.gn.routesChangesPois[i].split('-')[0] + '' == this.reportData[_idx].tourid + '') {
          this.gn.routesChangesPois[i] = '0-0'
        }
      }

      for (var i = 0; i < this.gn.routesChangesTest.length; i++) {
        if (this.gn.routesChangesTest[i].hederrbr.split('-')[0] + '' == this.reportData[_idx].tourid + '') {

          this.reportData[_idx].pois[this.gn.routesChangesTest[i].hederrbr.split('-')[1] - 1].note = this.gn.routesCh2[i]
          this.reportData[_idx].pois[this.gn.routesChangesTest[i].hederrbr.split('-')[1] - 1].visited = this.gn.routesCh3[i]

          this.reportData[_idx].pois[this.gn.routesChangesTest[i].hederrbr.split('-')[1] - 1].amount = this.gn.routesCh5[i]
          this.reportData[_idx].pois[this.gn.routesChangesTest[i].hederrbr.split('-')[1] - 1].person = this.gn.routesCh6[i]
          this.reportData[_idx].pois[this.gn.routesChangesTest[i].hederrbr.split('-')[1] - 1].barcode = this.gn.routesCh7[i]
          this.reportData[_idx].pois[this.gn.routesChangesTest[i].hederrbr.split('-')[1] - 1].dtbank = this.gn.routesCh8[i]


          this.gn.routesChangesTest.splice(i, 1);
          this.gn.routesCh1.splice(i, 1);
          this.gn.routesCh2.splice(i, 1);
          this.gn.routesCh3.splice(i, 1);

          this.gn.routesCh4.splice(i, 1);
          this.gn.routesCh5.splice(i, 1);
          this.gn.routesCh6.splice(i, 1);
          this.gn.routesCh7.splice(i, 1);
          this.gn.routesCh8.splice(i, 1);
          i--;
        }
      }
    }
    console.log(this.reportData[_idx].show, ' this.reportData[_idx].show ')
  }

  addPoiNote(poiobj, hederid) {
    //this.reportDDD[idxMaster].data[i1].pois[i]
    if (this.gn.user.driverid + '' == '-1')
      return false;

    var _that = this
    let modal = this.modalCtrl.create(PoinotePage, {
      obj: poiobj, hederid: hederid, cb: function (note, noteid) {
        poiobj.note = note;
        poiobj.noteid = noteid;
      }
    }, { cssClass: "modal-fullscreen7" });
    modal.present()
  }

  printNalog(_u) {
    var _that = this
    let modal = this.modalCtrl.create(PrintreportPage, {
      did: _u, cb: function () {
        // _that.loadData()
      }
    }, { cssClass: "modal-fullscreen2" });
    modal.present()
  }

  historyNalog(_u, _c) {
    if (_c == 0)
      return false;

    var _that = this
    let modal = this.modalCtrl.create(HistorylognalogPage, {
      did: _u, cb: function () {
        // _that.loadData()
      }
    }, { cssClass: "modal-fullscreen" });
    modal.present()
  }

  proba(id: number, idx: number, idxmaster: number) {
    console.log(this.reportDDD, '_that.reportDDD')
  }

  deleteNalog(id: number, idxmaster: number, obj) {
    //debugger

    var info = ''

    var _dt = obj.sd1
    var tmpveh = obj.vehicleid
    var _dttmp = moment(_dt).add(obj.totaltime, 'seconds')
    var _dtstart = moment(_dt)
    var _now = moment()
    if ((_now) > (_dtstart) && (_now) < _dttmp) info = 'current'
    //debugger


    var _that = this;
    let alert = _that.alertCtrl.create({
      title: _that.dic.l["deleteNalog"],
      subTitle: _that.dic.l["areyouwantodellDuty"] + ' ' + id,
      buttons: [
        {
          text: _that.dic.l['ok'],
          handler: data => {
            _that.gn.loadWaiting();
            this.gn._Post('/api/gn/delNalogHeder', { id: this.gn.crypt(id) }, function (_data) {
              if (info == 'current') {
                //debugger
                _that.gn.Vehicles[_that.gn.VehiclesDic[tmpveh]].routedetails = '-1'
              }
              _that.gn.loaderWaiting.dismiss();


              // debugger

              // for (let i = 0; i < _that.reportDDD.length; i++) {
              //   for (let j = 0; j < _that.reportDDD[i].data.length; j++) {
              // _that.reportDDD[idxmaster].data.splice(idx, 1);
              _that.reportData.splice(idxmaster, 1);



              //     _that.reportDDD[idxmaster].data[j].splice(idx, 1);
              //     console.log(_that.reportData, 'report da vidam')
              // }
              // }
            })
          }
        },
        {
          text: _that.dic.l['cancel'],
          role: 'cancel'
        }
      ]
    });
    alert.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/routing/routebank/reportorderbank/currentfuturebanknalog.ts